import { render } from "./ColourField.vue?vue&type=template&id=e79a793c"
import script from "./ColourField.vue?vue&type=script&lang=js"
export * from "./ColourField.vue?vue&type=script&lang=js"

import "./ColourField.vue?vue&type=style&index=0&id=e79a793c&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__